import { IActivity } from '@eduwrite/shared';

export function getActivityPrompt(activity: Pick<IActivity, 'title' | 'instructions' | 'type' | 'config'>): string {
    if (activity.instructions?.trim()) return activity.instructions.trim();

    const config = activity.config as Record<string, unknown> | undefined;
    const typeSpecificText = [
        config?.prompt,
        config?.question,
        config?.targetText,
        config?.sentence,
        config?.word,
        config?.expression,
    ].find((value): value is string => typeof value === 'string' && value.trim().length > 0);

    return typeSpecificText?.trim() || activity.title;
}
